import React, { useState } from 'react';
import { X, AlertTriangle, Trash2 } from 'lucide-react';

const DeleteConfirmModal = ({ item, contentType, config, onClose, onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const getItemTitle = () => {
    if (item.title) return item.title;
    if (item.alt_text) return item.alt_text;
    return `${config.title} #${item.id}`;
  };

  const handleDelete = async () => {
    setLoading(true);

    try {
      await config.api.delete(item.id);
      onSuccess(item.id);
    } catch (error) {
      console.error('Error deleting item:', error);
      onError('❌ Silme işlemi sırasında hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const itemTitle = getItemTitle();
  const isConfirmValid = confirmText.toLowerCase() === 'sil';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-red-100 rounded-full">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">
              İçeriği Sil
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Item Preview */}
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-start space-x-3">
                      {(item.imageUrl || item.image_url) && (
          <img 
            src={item.imageUrl || item.image_url}
                  alt="Preview"
                  className="w-16 h-16 rounded-lg object-cover bg-gray-200"
                  onError={(e) => {
                    e.target.src = 'https://placehold.co/64x64/e5e7eb/9ca3af?text=?';
                  }}
                />
              )}
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-gray-900 truncate">
                  {itemTitle}
                </h3>
                {item.description && (
                  <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                    {item.description.length > 100 
                      ? item.description.substring(0, 100) + '...' 
                      : item.description
                    }
                  </p>
                )}
                <div className="text-xs text-gray-500 mt-2">
                  ID: {item.id} • {config.title}
                </div>
              </div>
            </div>
          </div>

          {/* Warning Message */}
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex items-start space-x-3">
              <AlertTriangle className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" />
              <div className="text-sm text-red-800">
                <p className="font-medium mb-1">⚠️ Dikkat!</p>
                <p>
                  Bu işlem <strong>geri alınamaz</strong>. İçerik kalıcı olarak silinecek ve 
                  web sitesinden kaldırılacaktır.
                </p>
              </div>
            </div>
          </div>

          {/* Confirmation Input */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Silmek için <span className="font-bold text-red-600">"sil"</span> yazın:
            </label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              placeholder="sil"
              autoComplete="off"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              İptal
            </button>
            <button
              onClick={handleDelete}
              disabled={!isConfirmValid || loading}
              className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
            >
              <Trash2 className="w-4 h-4" />
              <span>{loading ? 'Siliniyor...' : 'Kalıcı Olarak Sil'}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal; 